import { useState, useEffect, useRef } from 'preact/hooks'
import Icon from '@/components/snippets/icon/icon'
import { ProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const CollectionToolbar = ({ query, resultsCount }) => {
  const { handleOpenFilters, activeFilters } = useFilters()

  const activeFilterCount = activeFilters?.size
  const [isSticky, setIsSticky] = useState(false)
  const toolbarRef = useRef(null)

  const handleFilterOpen = () => {
    handleOpenFilters()
    document.querySelector('x-modal[data-id="filters"]')?.handleToggle()
  }

  const collectionTitle = window.collection?.title || `Showing ${resultsCount} Results for "${query}"`
  const collectionLinks = window.collection?.seo.full_links || []

  useEffect(() => {
    let toolbarOffsetTop = 0

    const handleScroll = () => {
      if (toolbarRef.current) {
        if (toolbarOffsetTop === 0) {
          toolbarOffsetTop = toolbarRef.current.offsetTop
        }

        const currentScroll = window.scrollY
        const headerHeight = document.querySelector('sticky-header')?.offsetHeight || 0
        setIsSticky(currentScroll > (toolbarOffsetTop - headerHeight - 10))
      }
    }

    if (toolbarRef.current) {
      toolbarOffsetTop = toolbarRef.current.offsetTop
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      ref={toolbarRef}
      className={`sticky top-[calc(var(--height-header-adapt)-1px)] lg:z-[49] grid h-[60px] w-full items-center grid-cols-1 lg:grid-cols-2 lg:justify-end lg-max:justify-between ${isSticky ? 'lg:justify-between' : ''} gap-x-gutter bg-secondary px-margin transition-all collection-toolbar lg:flex lg:gap-x-1 has-[[data-ui=visible]]:lg-max:z-60`}
    >
      <div className={`hidden items-stretch justify-start ${isSticky ? 'lg:flex' : ''}`}>
        <h2 className="h2 font-serif">{collectionTitle}</h2>
        {collectionLinks.length > 0 && (
          <div>
            <div className="flex flex-nowrap h-full items-center justify-start gap-x-1 overflow-auto  border-l border-r-neutral-medium ml-1.5 pl-1">
              {collectionLinks.map((link) => (
                <a key={link.title} href={link.url} className="paragraph-s min-w-fit link-fade" aria-label={link.title}>
                  {link.title}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-nowrap items-center justify-between lg:justify-end w-full lg:w-fit">
        <div className='order-2 lg:order-1 lg-max:justify-self-center lg:border-r lg:border-r-neutral-medium lg:pr-1.5'>
          <ProductCount />
        </div>
        <div className='order-1 lg:order-2 lg:pl-1.5'>
          <button
            id="toggle-filters"
            className={'flex items-center gap-x-0.375 link-fade'}
            onClick={handleFilterOpen}
            aria-label="Toggle Filters"
          >
            <div className="h-[15px] w-[15px] children:size-full">
              <Icon id="filter" />
            </div>
            <span className="filters__toggle paragraph-s text-s capitalize">
              Filter &amp; Sort{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
